import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// The one Archive confirmation on the Speakers roster and profile (TMS-1563).
// It owns no form: a row's Archive, the profile's Archive and the bulk bar's
// Archive Selected each sit in their own server-rendered form, and the dialog
// submits whichever one raised it, so every submit keeps the CSRF token it was
// rendered with and nothing rewrites a form's action.
export default class extends Controller {
  static targets = ["modal", "title", "subject"]

  // One speaker: the trigger names them.
  open(event) {
    event.preventDefault()

    const trigger = event.currentTarget
    this.show(trigger.form, [trigger.dataset.speakerName])
  }

  // The ticked rows of the bulk bar's table, named when there is just one.
  openBulk(event) {
    event.preventDefault()

    const names = this.selectedRows().map(row => row.dataset.speakerName)
    if (names.length === 0) return

    this.show(event.currentTarget.form, names)
  }

  confirm() {
    if (!this.pendingForm) return

    const form = this.pendingForm
    this.pendingForm = null
    form.requestSubmit()
  }

  show(form, names) {
    this.pendingForm = form
    const several = names.length > 1

    this.titleTarget.textContent = several ? "Archive speakers" : "Archive speaker"
    this.subjectTarget.textContent = several ? `${names.length} speakers` : names[0]

    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  selectedRows() {
    return [...this.element.querySelectorAll('[data-bulk-select-target="checkbox"]:checked')]
      .map(checkbox => checkbox.closest("tr"))
      .filter(row => row && !row.hidden)
  }
}
